<template>
  <div class="home">
    <h1>{{ homeTitle }}</h1>
    <div class="user-note" v-if="allAreasCompleted">
      <p>You have finished all rooms. You may now submit your inspection.</p>
    </div>
    <div class="user-note" v-if="!allAreasCompleted">
      <p>You must complete all of the following areas to finish your inspection.</p><p>Select a room to begin.</p>
    </div>
    <ul class="area-list" v-if="!allAreasCompleted">
      <li v-for="area in areas" :key="area.InspectionAreaID" :value="area.InspectionAreaID" v-bind:class="{ completed: isCompleted( area.InspectionAreaID ), light: isCompleted( area.InspectionAreaID ) }">
          <router-link :to="'/area/' + area.InspectionAreaID">
            <div class="area-list__title">{{ area.Name }}</div>
            <font-awesome-icon icon="check" v-if="isCompleted( area.InspectionAreaID )"></font-awesome-icon>
        </router-link>
      </li>
    </ul>
    <div class="finalize-area" v-if="allAreasCompleted">
      <service-issue />
      <div class="button-area">
        <button type="button" v-on:click="finalizeInspection" :disabled="!allAreasCompleted">Submit Inspection</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import router from '@/router.js';
import ServiceIssue from '@/components/service-issue.vue';

export default {
  name: 'home',
  data : function(){
    return {
      hideForm : false
    }
  },
  components: {
    ServiceIssue
  },
  computed : {
    homeTitle : function(){
      return this.allAreasCompleted ? "Finalize Inspection" : "Home";
    },
    areas : function(){
      if( this.$store.state.inspection && this.$store.state.inspection.hasOwnProperty('InspectionAreas') ){
        return this.$store.state.inspection.InspectionAreas;
      }else{
        return null;
      }
    },
    allAreasCompleted : function(){
      return this.$store.state.allAreasCompleted;
    }
  },
  methods : {
    isCompleted( id ){
      return this.$store.state.completedAreas.hasOwnProperty( id );
    },
    finalizeInspection(){
          this.hideForm = true;
          this.$store.dispatch( 'finalizeInspection' ).then( () => {
            this.$store.dispatch( 'logOut' );
            this.$store.dispatch( 'postMessage', { msg : 'Your inspection has been submitted. Thank you!', timeout : 0, allowClose : true });
            router.push('/login');
        }).catch( reason => {
            this.$store.dispatch( 'postMessage', { msg : 'Could not submit inspection Please try again.', timeout : 8000, allowClose : true });
            console.log('ERROR: ', reason);
            this.hideForm = false;
        });
    }
  }
}
</script>
